import { render, staticRenderFns } from "./navBlock.vue?vue&type=template&id=1d5b6852&scoped=true&"
import script from "./navBlock.vue?vue&type=script&lang=js&"
export * from "./navBlock.vue?vue&type=script&lang=js&"
import style0 from "./navBlock.vue?vue&type=style&index=0&id=1d5b6852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b6852",
  null
  
)

export default component.exports